import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectSubmitFormViewTopBar } from "./TopBar"

export const projectFormSubmitterViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectSubmitFormViewTopBar,
}
